import { XCircle } from "lucide-react";

import { Button } from "@/ui/common";
import {
  Modal,
  ModalClose,
  ModalContent,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@/ui/common/Modal";

interface NotQualifyModalProps {
  show: boolean;
  onClose: () => void;
  title: string;
  description: string;
  handleEndIntake?: () => void;
  isLoading?: boolean;
}

export function NotQualifyModal({
  show,
  onClose,
  title,
  description,
  handleEndIntake,
  isLoading,
}: NotQualifyModalProps) {
  return (
    <Modal open={show} onOpenChange={onClose}>
      <ModalContent className="left-1/2 top-1/2 max-w-md -translate-x-1/2 -translate-y-1/2">
        <ModalHeader>
          <div className="relative flex items-center justify-center">
            <div className="absolute size-9 rounded-full bg-error-50" />
            <div className="absolute size-7 rounded-full bg-error-100" />
            <XCircle
              className="z-10 rounded-full bg-error-100 text-error-700"
              size={20}
            />
          </div>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>
        <ModalDescription>{description}</ModalDescription>
        <ModalFooter className="flex gap-3">
          {handleEndIntake && (
            <Button
              variant="secondaryRed"
              onClick={handleEndIntake}
              disabled={isLoading}
              isLoading={isLoading}
            >
              End intake
            </Button>
          )}
          <Button onClick={onClose} disabled={isLoading}>
            Back to form
          </Button>
        </ModalFooter>
        <ModalClose />
      </ModalContent>
    </Modal>
  );
}
